export default "__VITE_ASSET__BqgdAixo__"